import request from '@/utils/request'

/**
 * 获取服务列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回服务列表
 */
export function listServices(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/service.listServices',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加服务
 * @param {Object} data 服务数据
 * @returns {Promise} 返回操作结果
 */
export function saveService(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/service.saveService',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新服务
 * @param {Object} data 服务数据
 * @returns {Promise} 返回操作结果
 */
export function updateService(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/service.updateService',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除服务
 * @param {Object} data 服务数据
 * @returns {Promise} 返回操作结果
 */
export function deleteService(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/service.deleteService',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取应用信息
 * @param {Object} params 查询参数
 * @returns {Promise} 返回应用信息
 */
export function getAppInfo(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app.listApps',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res.apps[0])
    }).catch(error => {
      reject(error)
    })
  })
}